import { render, staticRenderFns } from "./EditSector.vue?vue&type=template&id=e4f482a0&lang=true&"
import script from "./EditSector.vue?vue&type=script&lang=js&"
export * from "./EditSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports